import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var NavBar = styled(Box).withConfig({
  componentId: "sc-1m7p6ln-0"
})(["display:flex;align-items:center;justify-content:space-between;height:var(--navbar-height);width:100%;padding:0 ", ";border:none;color:", ";background-color:", ";"], spacing("lg"), palette("neutral.0"), palette("neutral.900"));
var Brand = styled(Box).withConfig({
  componentId: "sc-1m7p6ln-1"
})(["display:flex;align-items:center;", ""], function (_ref) {
  var href = _ref.href;
  return href && css(["text-decoration:none;transition:color 200ms ease-in;color:", ";cursor:pointer;&:hover{color:", ";}"], palette("neutral.50"), palette("neutral.400"));
});
var Menu = styled(Box).attrs(function (_ref2) {
  var justify = _ref2.justify;
  return {
    justifyContent: justify
  };
}).withConfig({
  componentId: "sc-1m7p6ln-2"
})(["display:flex;flex:1 1 0;align-items:center;width:100%;"]);
var NavBarDrawer = styled(Box).withConfig({
  componentId: "sc-1m7p6ln-3"
})(["display:flex;align-items:center;justify-content:space-between;height:var(--navbar-height);width:100%;padding:0 ", ";border:none;color:", ";background-color:", ";", ""], spacing("lg"), palette("neutral.0"), palette("neutral.900"), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint("sm")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        padding: 0 ", ";\n    "])), spacing("xs"));
});
var Divider = styled.hr.withConfig({
  componentId: "sc-1m7p6ln-4"
})(["border-width:0px 0px 0px 1px;border-image:initial;border-color:inherit;border-style:solid;height:28px;margin:", ";color:", ";"], spacing("md"), palette("neutral.700"));
export { Brand, Divider, Menu, NavBar, NavBarDrawer };